import axios from 'axios'
import { MessageBox, Loading } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import $message from '@/utils/message'

// create an axios instance
const service = axios.create({
  baseURL: window.config.NODE_ENV !== 'production' ? process.env.VUE_APP_BASE_API : window.config.VUE_APP_SERVER_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 2 * 60 * 1000 // request timeout
})

const urlReqTimeMap = {}
let loading
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    console.log('request config', config)
    config._requestTime = new Date().getTime()
    urlReqTimeMap[config.url] = config._requestTime
    let showLoading = false
    if (config.showLoading === true) {
      showLoading = true
    }
    if (showLoading) {
      loading = Loading.service({
        text: config.loadingText || 'Loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
    if (store.getters.token) {
      // let each request carry token
      // ['token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    console.log('response', response)
    const res = response.data
    if (loading) {
      loading.close()
    }
    const config = response.config
    res._config = config
    const lastReqTime = urlReqTimeMap[config.url]
    if (!lastReqTime || config._requestTime >= lastReqTime) {
      console.debug('this is the last request', config.url)
      res._isLastRequest = true
    } else {
      console.debug('not the last request', config.url)
      res._isLastRequest = false
    }

    // if the custom code is not 20000, it is judged as an error.
    if (!String(res.code).startsWith('200')) {
      $message({
        message: res.msg || res.message || 'Error',
        type: 'error'
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (loading) {
      loading.close()
    }
    console.log('response err', error, error.response, error.request) // for debug
    let message = error.msg || error.message || 'Error'
    if (error.response) {
      if (error.response.data) {
        message = error.response.data.msg || message
      }
    }
    $message({
      message: message,
      type: 'error'
    })
    return Promise.reject(error)
  }
)

export default service
